import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: "4jnhxc9y",
    dataset: "production",
    apiVersion: '2021-05-19', // use current UTC date - see "specifying API version"!
    token: "skuUDQrrPqcmewkcBY9pmaP4wEyUS6JjblGkNL5YZUi14wOQNKSZbD6yrJcBgDSb58gdHfBgohMCvrJcZUsNObcBDiYsSSoO1xSrpR4oUL1xARq5Ob1H4guLi0Mv7XxCHTE4izmlRZbQzVEgEZDJLlwnREgEMGulY7NffVvi70if9dXaSFHq", // or leave blank for unauthenticated usage
    useCdn: true, // `false` if you want to ensure fresh data
})